import Icon from '../components/Icon.vue'

Icon.register({"files-o":{"width":1792,"height":1792,"paths":[{"d":"M1696 384q40 0 68 28t28 68v1216q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-288h-544q-40 0-68-28t-28-68v-672q0-40 20-88t48-76l408-408q28-28 76-48t88-20h416q40 0 68 28t28 68v328q68-40 128-40h416zM1152 597l-299 299h299v-299zM512 213l-299 299h299v-299zM708 860l316-316v-416h-384v416q0 40-28 68t-68 28h-416v640h512v-256q0-40 20-88t48-76zM1664 1664v-1152h-384v416q0 40-28 68t-68 28h-416v640h896z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/files-o.js
// module id = 932
// module chunks = 0